<template>
  <div>
    <span class="d-block text-center text-lowercase mini-rate">
      <span v-if="rates && multiplyer && rates * multiplyer < 1000000">
        {{ rates === 0 ? null : (rates * multiplyer) | currencyFormat(0) }}
      </span>
      <span v-else-if="rates && multiplyer && rates * multiplyer > 1000000">
        1cr+
      </span>
      <span v-else>
        {{ rates === 0 ? null : rates | currencyFormat(0) }}
      </span>
    </span>
  </div>
</template>
<script>
export default {
  name: 'Multiplyer',
  props: {
    rates: { type: [Number, String], default: 1, required: false },
    multiplyer: { type: Number, default: 1, required: false }
  }
}
</script>
